var map = {
	"./BrightSeries/1.jpg": "44fc",
	"./BrightSeries/2.jpg": "3050",
	"./BrightSeries/3.jpg": "7a2b",
	"./BrightSeries/4.jpg": "b900",
	"./HouseOfLove/1.jpg": "5414",
	"./HouseOfLove/2.jpg": "9ac0",
	"./HouseOfLove/3.jpg": "949a",
	"./SXServiceTransport/1.jpg": "13af",
	"./SXServiceTransport/2.jpg": "2fff",
	"./SXServiceTransport/3.jpg": "f4ae",
	"./ShuiXingVentures/1.jpg": "7afa",
	"./ShuiXingVentures/1.mp4": "1442",
	"./ShuiXingVentures/2.jpg": "8c91",
	"./ShuiXingVentures/3.jpg": "faf8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "015a";